import React from 'react';
import { AlertTriangle } from 'lucide-react';

/**
 * "Public Property needs resolution" indicator (DOMA 13121348574).
 *
 * A seller lead is matched against the Public Property universe (every property
 * in Australia) and the working CRM Property carries that outcome in
 * `public_match_status`. When a property or lead could not be matched, an agent
 * or admin has to resolve it by hand, so this badge calls that out.
 *
 * It is deliberately invisible in the normal case: a matched / manually matched
 * property, one still pending, or a legacy record with no status, shows nothing.
 * Only "unmatched" and "needs_review" raise the amber flag, the same tone the
 * rest of the CRM uses for "needs attention" (see DuplicateCheck).
 */
const NEEDS_RESOLUTION = ['unmatched', 'needs_review'];

const PublicMatchBadge = ({ status, className = '' }) => {
  const key = (status || '').trim();
  // Matched, manual, pending and blank are the quiet cases: no badge, so the
  // header reads clean until something actually needs a person.
  if (!NEEDS_RESOLUTION.includes(key)) return null;

  return (
    <span
      title="Public Property unmatched - needs resolution"
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded text-[10px] font-bold bg-amber-50 text-amber-700 border border-amber-300 whitespace-nowrap ${className}`}
    >
      <AlertTriangle className="w-3 h-3" />
      Needs resolution
    </span>
  );
};

export default PublicMatchBadge;
